/** 列表/选图展示用缩略图，无则回退原图（兼容旧数据） */
export function materialPreviewUrl(item) {
  if (!item) return "";
  return item.file_thumb_path || item.fileThumbPath || item.file_down_path || item.fileDownPath || "";
}

export function projectCoverUrl(row) {
  if (!row) return "";
  return row.project_img_thumb || row.projectImgThumb || row.project_img || row.projectImg || "";
}
